import Vuex from "vuex";
import Vue from "vue";
import createPersistedState from "vuex-persistedstate";
import auth from "./modules/auth.js"
import params from "./modules/params.js"
import orders from "./modules/orders.js"
import client from "./modules/client.js"
import rates from "./modules/rates.js"

// Load Vuex
// Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        auth,
        params,
        orders,
        client,
        rates
    },
    plugins: [createPersistedState()],
})